import { Button, Dialog } from "@mui/material";
import React from "react";
import { getMappedTwilioErrorDocs } from "../../utils/twilioErrorMessages";

const ErrorModal = ({ open, setOpen, setCallData, call_data, err_msg, setErrorMsg }) => {
  const twilioDocs = getMappedTwilioErrorDocs(err_msg);

  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Error Initiating Call</div>


        <div className="lg:text-[14px] text-[13px] text-center">
          {twilioDocs ? (
            <>
              <a
                href={twilioDocs.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#605BFF] underline"
              >
                Twilio Error {twilioDocs.code}
              </a>
              {twilioDocs.detail}
            </>
          ) : (
            err_msg
          )}
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    setOpen(false)
                    setErrorMsg(null)
                   

                    let a = document.createElement('a')
                    a.href ='mailto:help@twilanswer.com'
                    a.click()
                }}
                >
                  Help
                </Button>

                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(232,231,249,1)',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    setOpen(false);
                    setErrorMsg(null);
                    setCallData((prev) => ({
                      ...prev,
                      recipient: "",
                      callMethod: "forwarding_device",
                    }));
                  }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default ErrorModal;
